module.exports = __webpack_public_path__ + "static/fonts/AlibabaPuHuiTi-2-45-Light.f2f9486d.ttf";